export default "__VITE_ASSET__vGnMmlFM__"